import { Button, Paper } from "@mantine/core";
import { Controller, useForm } from "react-hook-form";
import { Select, TextInput } from "react-hook-form-mantine";

import IconSelect from "../IconSelect";
import PagesEditor from "./PagesEditor";
import { extractDirtyData } from "../../utils/dirtyData";
import { web_pageFormSchema } from "@congrs/schemas";
import resolver from "@congrs/resolver";

const PageForm = ({
  initialData,
  onSubmit,
  isSubmitting,
  isSuccess,
  mode = "create",
}) => {
  const defaultValues = {
    title: initialData?.title || "",
    icon: initialData?.icon || "",
    content: initialData?.content ?? undefined,
    isDraft: initialData?.isDraft?.toString() || "true",
    type: initialData?.type || "content",
    linkUrl: initialData?.linkUrl ?? undefined,
  };

  const {
    control,
    handleSubmit,
    formState: { isDirty, dirtyFields },
    reset,
    watch,
  } = useForm({
    defaultValues,
    resolver: resolver(web_pageFormSchema, { allErrors: true }),
  });

  const icon = watch("icon");
  const type = watch("type");

  const handleFormSubmit = (data) => {
    const dataToSubmit = {
      ...data,
      isDraft: data.isDraft === "true",
    };

    const submitData =
      mode === "edit"
        ? extractDirtyData(dataToSubmit, dirtyFields)
        : dataToSubmit;

    onSubmit(submitData, {
      onSuccess: () => reset(mode === "edit" ? data : initialData),
    });
  };

  return (
    <Paper withBorder shadow="md" p="sm" mt="sm" radius="md">
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <TextInput
          label="Page title"
          placeholder="Sample page"
          control={control}
          name="title"
          mt="sm"
        />
        <IconSelect
          label="Icon"
          placeholder="Select icon"
          control={control}
          name="icon"
          currentIcon={icon}
          mt="sm"
        />
        <Select
          label="Page status"
          placeholder="Select page status"
          control={control}
          name="isDraft"
          data={[
            { value: "true", label: "Draft" },
            { value: "false", label: "Published" },
          ]}
          mt="sm"
        />
        <Select
          label="Page type"
          placeholder="Select page type"
          control={control}
          name="type"
          data={[
            { value: "content", label: "Content" },
            { value: "link", label: "Link" },
          ]}
          mt="sm"
        />
        {type === "link" && (
          <TextInput
            label="Link URL"
            placeholder="https://www.google.com"
            control={control}
            name="linkUrl"
            mt="sm"
          />
        )}
        {type === "content" && (
          <Controller
            name="content"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <PagesEditor
                onChange={onChange}
                content={value ? JSON.parse(value) : null}
                error={error}
              />
            )}
          />
        )}
        <Button
          type="submit"
          loading={isSubmitting}
          disabled={isSuccess || (mode === "edit" && !isDirty)}
          mt="sm"
        >
          {mode === "create" ? "Create page" : "Update page"}
        </Button>
      </form>
    </Paper>
  );
};

export default PageForm;
